export const expandedVSForMobile = [
  'make',
  'make_part',
  'make_model',
  'make_model_part',
]

const seoPageTypes = [
  'year_make_model',
  'vlp',
  'part',
  'part_make_model_year',
  'ymm_bp_sku',
  'ymm_sku',
  'ymms_sku',
  'ymmse_sku',
  'ymms_pla_sku',
  'ymm_bp_sku_pla',
  'ymm_sku_pla',
  'ymms_sku_pla',
  'ymmse_sku_pla',
  'ymms_pla_sku_pla',
]

export default seoPageTypes
